/**
 * Notifications (devis, module « Notifications ») : alertes par courriel sur
 * l'adresse professionnelle du client — nouveau dossier, pièce reçue, pièce
 * manquante, document déposé par un avocat — plus les codes de vérification
 * des liens sécurisés.
 */
export const NOTIFICATION_STATUSES = ["en_attente", "envoyee", "simulee", "echec"] as const;
export type NotificationStatus = (typeof NOTIFICATION_STATUSES)[number];
export const NOTIFICATION_STATUS_LABELS: Record<NotificationStatus, string> = {
  en_attente: "En attente",
  envoyee: "Envoyée",
  simulee: "Simulée (sans clés Mailjet)",
  echec: "Échec",
};

export interface Notification {
  id: string;
  toEmail: string;
  subject: string;
  event: string | null;
  status: NotificationStatus;
  attempts: number;
  error: string | null;
  createdAt: number | string;
  sentAt: number | string | null;
}
